

import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Paper as MaterialPaper, Link, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, IconButton, ListSubheader } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { Exam, ExamPaper } from '../../../interfaces/examiner/Exam'
import React, { Fragment } from 'react';
import ExaminerContainer from '../ExaminerContainer';

import '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import SavingIndicator from '../../../components/SavingIndicator';
import SaveCancelButtons from '../../../components/SaveCancelButtons';
import { Cancel, PictureAsPdf } from '@material-ui/icons';
import AddPaperToExamDialog from './AddPaperToExamDialog';
import { exec } from 'child_process';
import { Student } from '../../../interfaces/examiner/Student';
import DataTable from 'react-data-table-component';
import ExaminerStudentsList from './ExaminerStudentsList';
import request, { isLoggedIn } from '../../../api';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import { Paper } from '../../../interfaces/shared/Paper';
import FileSaver from 'file-saver';
import { UnsavedChangesHandler } from '../../../utils/unsavedChanges';
import UnsavedChangesDialog from '../../../components/UnsavedChangesDialog';

interface Props {
    id: string
}

interface State {
  exam: Exam | null,
  saving: boolean,
  showAddPaperDialog: boolean,
  remarking: boolean
  teacherFilter: string | undefined
  studentSearch: string
  uploadMessage: string
  hasChanges: boolean
  allowedSchoolsSearchQuery: string
  excludedSchoolsSearchQuery: string
  showUnsavedDialog: boolean
  teacherFilterSearch: string
}

class ExaminerExamPage extends React.Component<Props & RouteComponentProps, State> {

  private unsavedChanges = new UnsavedChangesHandler()

  constructor(props: Props & RouteComponentProps) {

    super(props)

    this.state = {
      exam: null,
      saving: false,
      showAddPaperDialog: false,
      hasChanges: false,
      remarking: false,
      teacherFilter: new URLSearchParams(props.location.search).get('schoolFilter') || undefined,
      studentSearch: new URLSearchParams(props.location.search).get('studentSearch') || '',
      uploadMessage: '',
      allowedSchoolsSearchQuery: '',
      excludedSchoolsSearchQuery: '',
      showUnsavedDialog: false,
      teacherFilterSearch: '',
    }
  }


  render() {

    let { exam, saving, showAddPaperDialog, teacherFilter, studentSearch, uploadMessage } = this.state

    if (!isLoggedIn('examiner')) {
      return <Redirect to='/login' />
    }


    if (!exam) {
      return <ExaminerContainer heading={"Loading..."}>Loading...</ExaminerContainer>
    }

    return (
      <ExaminerContainer heading={exam.title}>
        <UnsavedChangesDialog
          open={this.state.showUnsavedDialog}
          onYes={this.handleUnsavedYes}
          onNo={this.handleUnsavedNo}
        />
        {
          showAddPaperDialog &&
          <AddPaperToExamDialog exam={exam} onAdd={this.onAddPaper} onClose={this.onCloseAddPaperDialog} />
        }
        <SavingIndicator saving={saving} />
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Exam Title"
          fullWidth
          defaultValue={exam.title}
          onChange={this.handleTitleChange}
        />
        <br />
        <br />
        <InputLabel id="type">Exam Type</InputLabel>
        <Select
          labelId="type"
          name="type"
          value={exam.type}
          onChange={this.handleChange}
          disabled={exam.isLive}
        >
          <MenuItem value={"ONLINE"}>Online</MenuItem>
          <MenuItem value={"PDF"}>PDF</MenuItem>
        </Select>
        <br />
        <br />
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Fragment>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Opening Date"
              value={exam.openDate}
              onChange={this.handleOpenDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
            &nbsp;
            &nbsp;
            <KeyboardTimePicker
              margin="normal"
              id="time-picker"
              label="Opening Time"
              format="hh:mm"
              value={exam.openDate}
              onChange={this.handleOpenDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change time',
              }}
            />
            <br />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Closing Date"
              value={exam.closeDate}
              onChange={this.handleCloseDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
            &nbsp;
            &nbsp;
            <KeyboardTimePicker
              margin="normal"
              id="time-picker"
              label="Closing Time"
              format="hh:mm"
              value={exam.closeDate}
              onChange={this.handleCloseDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change time',
              }}
            />
          </Fragment>
        </MuiPickersUtilsProvider>
        <br />
        <br />
        <InputLabel id="pricingmodelLabel">Pricing Model</InputLabel>
        <Select
          labelId="pricingmodelLabel"
          name="pricingModel"
          value={exam.pricingModel}
          onChange={this.handleChange}
          disabled={exam.isLive}
        >
          <MenuItem value={"PER_STUDENT"}>Per Student (same for all)</MenuItem>
          <MenuItem value={"FLAT_FEE"}>Flat Fee (same for all)</MenuItem>
          <MenuItem value={"FREE"}>Free</MenuItem>
          <MenuItem value={"FLAT_FEE_INT"}>UK Free/Int Flat Fee</MenuItem>
          <MenuItem value={"LOCKED"}>Locked: chosen schools only</MenuItem>
        </Select>
        <br />
        <br />
        <InputLabel id="allowInvoicesLabel">Allow Invoices</InputLabel>
        <Select
          labelId="allowInvoicesLabel"
          name="allowInvoicesByLocation"
          value={exam.allowInvoicesByLocation}
          onChange={this.handleChange}
          disabled={exam.isLive}
        >
          <MenuItem value={"ALL"}>All Schools</MenuItem>
          <MenuItem value={"NONE"}>No Schools</MenuItem>
          <MenuItem value={"UK_ONLY"}>Only UK Schools</MenuItem>
        </Select>
        <br />
        <br />
        <InputLabel id="whereCanViewLabel">Restrict Teachers Who Can View</InputLabel>
        <Select
          labelId="whereCanViewLabel"
          name="whereCanView"
          value={exam.whereCanView}
          onChange={this.handleChange}
          disabled={exam.isLive}
        >
          <MenuItem value={"ALL"}>All Schools</MenuItem>
          <MenuItem value={"OVERSEAS_ONLY"}>Only Overseas Schools</MenuItem>
          <MenuItem value={"UK_ONLY"}>Only UK Schools</MenuItem>
        </Select>
        <br />
        <br />
        <InputLabel id="schoolAvailabilityModeLabel">School Availability</InputLabel>
        <Select
          labelId="schoolAvailabilityModeLabel"
          name="schoolAvailabilityMode"
          value={exam.schoolAvailabilityMode || 'ALL'}
          onChange={this.handleChange}
          disabled={exam.isLive}
        >
          <MenuItem value={"ALL"}>All Schools</MenuItem>
          <MenuItem value={"SELECTED"}>Selected Schools Only</MenuItem>
        </Select>
        <br />
        <br />
        <InputLabel id="aggregationMethodLabel">Score Calculation Method</InputLabel>
        <Select
          labelId="aggregationMethodLabel"
          name="aggregationMethod"
          value={exam.aggregationMethod || 'TOTAL_RAW'}
          onChange={this.handleChange}
          disabled={exam.isLive}
        >
          <MenuItem value={"TOTAL_RAW"}>Total Raw Scores (papers with more marks count more)</MenuItem>
          <MenuItem value={"AVG_PERCENTAGE"}>Average Percentage (each paper counts equally)</MenuItem>
        </Select>
        {exam.schoolAvailabilityMode === 'SELECTED' && (
          <Fragment>
            <br />
            <br />
            <Button
              color="primary"
              variant="outlined"
              onClick={() => this.handleImportSchoolCodes('replace')}
              disabled={exam?.isLive}
              style={{ marginRight: 8 }}
            >
              Upload school codes CSV (Replace)
            </Button>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => this.handleImportSchoolCodes('add')}
              disabled={exam?.isLive}
            >
              Upload school codes CSV (Add)
            </Button>
            <br />
            <br />
            <div>
              <strong>Allowed School Codes ({(exam?.allowedSchools || []).length}):</strong>
              {(exam?.allowedSchools || []).length > 0 && (
                <Button
                  size="small"
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    if (window.confirm('Remove all allowed school codes?')) {
                      this.handleBulkRemoveAllowedSchools(exam?.allowedSchools || [])
                    }
                  }}
                  disabled={exam?.isLive}
                  style={{ marginLeft: 8 }}
                >
                  Remove All
                </Button>
              )}
              <br />
              <br />
              {(exam?.allowedSchools || []).length > 0 ? (
                <Fragment>
                  <TextField
                    margin="dense"
                    id="allowedSchoolsSearch"
                    label="Search school codes..."
                    fullWidth
                    value={this.state.allowedSchoolsSearchQuery}
                    onChange={(e) => this.setState({ allowedSchoolsSearchQuery: e.target.value })}
                    style={{ marginBottom: 16 }}
                  />
                  <DataTable
                    columns={[
                      {
                        name: 'School Code',
                        selector: 'schoolCode',
                        sortable: true,
                      },
                      {
                        name: 'Actions',
                        cell: (row: { schoolCode: string }) => (
                          <IconButton
                            size="small"
                            onClick={() => this.handleRemoveAllowedSchool(row.schoolCode)}
                            disabled={exam?.isLive}
                            color="secondary"
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        ),
                        ignoreRowClick: true,
                        allowOverflow: true,
                        button: true,
                        width: '100px',
                      }
                    ]}
                    data={(exam?.allowedSchools || [])
                      .filter((code: string) =>
                        code.toLowerCase().includes(this.state.allowedSchoolsSearchQuery.toLowerCase())
                      )
                      .map((code: string) => ({ schoolCode: code }))}
                    pagination
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    noHeader
                    dense
                  />
                </Fragment>
              ) : (
                <p style={{ color: '#999' }}>No school codes uploaded yet. Upload a CSV file with 'schoolCode' column containing 3-letter codes.</p>
              )}
            </div>
          </Fragment>
        )}
        {exam?.schoolAvailabilityMode === 'ALL' && (
          <Fragment>
            <h3>Exclude Schools</h3>
            <p>Upload CSV with school codes to exclude from accessing this exam (when School Availability is set to ALL).</p>
            <br />
            <Button
              color="primary"
              variant="outlined"
              onClick={() => this.handleImportExcludedSchoolCodes('replace')}
              disabled={exam?.isLive}
              style={{ marginRight: 8 }}
            >
              Upload excluded school codes CSV (Replace)
            </Button>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => this.handleImportExcludedSchoolCodes('add')}
              disabled={exam?.isLive}
            >
              Upload excluded school codes CSV (Add)
            </Button>
            <br />
            <br />
            <div>
              <strong>Excluded School Codes ({(exam?.excludedSchools || []).length}):</strong>
              {(exam?.excludedSchools || []).length > 0 ? (
                <Fragment>
                  <br />
                  <br />
                  <TextField
                    margin="dense"
                    id="excludedSchoolsSearch"
                    label="Search school codes..."
                    fullWidth
                    value={this.state.excludedSchoolsSearchQuery}
                    onChange={(e) => this.setState({ excludedSchoolsSearchQuery: e.target.value })}
                    style={{ marginBottom: 16 }}
                  />
                  <DataTable
                    columns={[
                      {
                        name: 'School Code',
                        selector: 'schoolCode',
                        sortable: true,
                      },
                      {
                        name: 'Actions',
                        cell: (row: { schoolCode: string }) => (
                          <IconButton
                            size="small"
                            onClick={() => this.handleRemoveExcludedSchool(row.schoolCode)}
                            disabled={exam?.isLive}
                            color="secondary"
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        ),
                        ignoreRowClick: true,
                        allowOverflow: true,
                        button: true,
                        width: '100px',
                      }
                    ]}
                    data={(exam?.excludedSchools || [])
                      .filter((code: string) =>
                        code.toLowerCase().includes(this.state.excludedSchoolsSearchQuery.toLowerCase())
                      )
                      .map((code: string) => ({ schoolCode: code }))}
                    pagination
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    noHeader
                    dense
                  />
                </Fragment>
              ) : (
                <p style={{ color: '#999' }}>No excluded school codes. Upload a CSV file with 'schoolCode' column to exclude schools.</p>
              )}
            </div>
          </Fragment>
        )}
        <br />
        <br />
        <FormControlLabel
          control={
            <Checkbox checked={exam.freePlacesUkOnly} disabled={exam.isLive} onClick={() => this.handletoggleFreePlacesUkOnly()} />}
          label="Free places UK only?"
        />
        <br />
        <br />
        <FormControlLabel
          control={
            <Checkbox checked={exam.freePlacesNonFeePayingOnly} disabled={exam.isLive} onClick={() => this.handletoggleFreePlacesNonFeePayingOnly()} />}
          label="Free places Non-fee-paying only?"
        />
        <br />
        <br />
        {
          exam.pricingModel === "PER_STUDENT" &&
          <Fragment>
            <TextField
              margin="dense"
              name="numFreePlaces"
              label="Number of Free Places"
              fullWidth
              type="number"
              defaultValue={exam.numFreePlaces}
              onChange={this.handleChange}
              disabled={exam.isLive}
            />
            <TextField
              margin="dense"
              name="perStudentPrice"
              label="Price Per Student"
              fullWidth
              type="number"
              defaultValue={exam.perStudentPrice}
              onChange={this.handleChange}
              disabled={exam.isLive}
            />
            <TextField
              margin="dense"
              name="perStudentMaxPrice"
              label="Max Price"
              fullWidth
              type="number"
              defaultValue={exam.perStudentMaxPrice}
              onChange={this.handleChange}
              disabled={exam.isLive}
              helperText="Set to 0 for no maximum"
            />
          </Fragment>
        }
        {
          (exam.pricingModel === "FLAT_FEE" || exam.pricingModel === "FLAT_FEE_INT") &&
          <Fragment>
            {exam.pricingModel === "FLAT_FEE_INT" && "Unlimited free places for UK schools & Flat Fee for international schools."}
            <TextField
              margin="dense"
              name="numFreePlaces"
              label="Number of Free Places"
              fullWidth
              type="number"
              defaultValue={exam.numFreePlaces}
              onChange={this.handleChange}
              disabled={exam.isLive}
            />
            <TextField
              margin="dense"
              name="flatFeePrice"
              label="Price"
              fullWidth
              type="number"
              defaultValue={exam.flatFeePrice}
              onChange={this.handleChange}
              disabled={exam.isLive}
            />
          </Fragment>
        }
        <br />
        <br />
        <SaveCancelButtons
          onSave={this.handleSave}
          onCancel={this.handleCancel}
          saveLoading={this.state.saving}
          saveDisabled={!this.state.hasChanges}
        />
        <br />
        <br />
        {exam.type == "ONLINE" && <TextField
          margin="dense"
          id="studentRubric"
          label="Rubric for Students"
          multiline
          rows={16}
          fullWidth
          variant="filled"
          defaultValue={exam.studentRubric}
          onChange={this.handleStudentRubricChange}
        />}
        <TextField
          margin="dense"
          id="teacherRubric"
          label="Rubric for Teachers"
          multiline
          rows={16}
          fullWidth
          variant="filled"
          defaultValue={exam.teacherRubric}
          onChange={this.handleTeacherRubricChange}
        />
        <br />
        <br />
        {exam.type === "PDF" && <Fragment>
          {exam.pdf ? <Fragment><Button color="primary" variant="outlined" onClick={() => this.deletePdf(1)}>Delete PDF1</Button><Button onClick={() => this.downloadPdf(1)}><PictureAsPdf /></Button></Fragment> : <Button color="primary" variant="outlined" onClick={() => this.addPdf(1)}>+ Add PDF1</Button>}
          {exam.pdf2 ? <Fragment><Button color="primary" variant="outlined" onClick={() => this.deletePdf(2)}>Delete PDF2</Button><Button onClick={() => this.downloadPdf(2)}><PictureAsPdf /></Button></Fragment> : <Button color="primary" variant="outlined" onClick={() => this.addPdf(2)}>+ Add PDF2</Button>}
        </Fragment>}
        <br />
        <br />
        {!exam.isArchived && !exam.isLive && <Button color="primary" variant="outlined" onClick={this.handletoggleLive}>
          Allow teachers to view
        </Button>}
        {!exam.isArchived && exam.isLive && <Button color="primary" variant="outlined" onClick={this.handletoggleLive}>
          Prevent teachers from viewing
        </Button>}
        <br />
        <br />
        {exam.pricingModel === "LOCKED" && <Button color="primary" variant="outlined" onClick={this.handleImportCSV2}>
          Upload school codes for access
        </Button>}
        <br />
        <br />
        {exam.teacherHack!.length} teachers signed up.
        <br />
        <br />
        <Button color="primary" variant="outlined" onClick={this.downloadSignedUp}>
          Download signed up teacher details
        </Button>
        <Button color="primary" variant="outlined" onClick={this.downloadNotSignedUp}>
          Download teacher list with consent NOT signed up
        </Button>
        <br />
        <br />
        {exam.type === "ONLINE" && !exam.isArchived && <Fragment>{(
          this.state.remarking ?
            <Button color="primary" variant="outlined" disabled>Re-marking...</Button>
            :
            <Button color="primary" variant="outlined" onClick={this.remark}>Re-mark all students</Button>)}
          <br />
          <br />
        </Fragment>}
        {exam.type === "ONLINE" && <Fragment>
          <Button color="primary" variant="outlined" onClick={this.handleImportCSV}>Upload Medals</Button>
          {exam.certificate ? <Fragment><Button color="primary" variant="outlined" onClick={this.deleteCertificate}>Delete Certificate</Button><Button onClick={() => this.downloadCertificate()}><PictureAsPdf /></Button></Fragment> : <Button color="primary" variant="outlined" onClick={this.addCertificate}>+ Add Certificate</Button>}
          {uploadMessage ? <p> {uploadMessage} </p> : <br/>}
          <br />
          <FormControlLabel
            control={
              <Checkbox checked={exam.marksReleased} onClick={() => this.handletoggleReleased()} />}
            label="Release marks?"
          />
          <br />
          <br />
        </Fragment>}
        <FormControlLabel
          control={
            <Checkbox checked={exam.isArchived} onClick={() => this.handletoggleArchived()} />}
          label="Archive exam?"
        />
        {exam.type === "ONLINE" && <Fragment><h2>Papers</h2>

          <TableContainer component={MaterialPaper}>
            <Table aria-label="simple table">
              <TableBody>
                {exam.papers.map((paper: ExamPaper, i: number) => (
                  <TableRow key={paper.id}>
                    {!exam!.isArchived &&
                      <TableCell component="th" scope="option">
                        {i > 0 && <Button onClick={() => this.movePaper(i, i - 1)}>▲</Button>}
                        {i < exam!.papers.length - 1 && <Button onClick={() => this.movePaper(i, i + 1)}>▼</Button>}
                        <Button onClick={() => this.removePaper(paper, i)}><Cancel /></Button>
                      </TableCell>}
                    <TableCell align="left">
                      <Link href={'/examiner/papers/' + paper.id}>{paper.title}</Link>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={3}>
                    {!exam!.isArchived && <Button color="primary" variant="outlined" onClick={this.addPaper}>
                      + Add Paper
                    </Button>}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <h2 id="students" style={{ scrollMarginTop: 16 }}>Students</h2>
          Filter by school:
          {(() => {
            const teacherFilterSearch = this.state.teacherFilterSearch.trim().toLowerCase()
            const teachers = exam.teacherHack || []
            const filteredTeachers = teacherFilterSearch
              ? teachers.filter((t) =>
                (t.schoolCode || '').toLowerCase().includes(teacherFilterSearch) ||
                (t.school || '').toLowerCase().includes(teacherFilterSearch)
              )
              : teachers
            const selectedTeacher = teachers.find((t) => t.id === teacherFilter)

            return (
              <Select
                margin="dense"
                id="teacher"
                label="Teacher"
                value={teacherFilter || ''}
                displayEmpty
                onChange={(e) => this.handleTeacherFilterChange(e)}
                onClose={() => this.setState({ teacherFilterSearch: '' })}
                style={{ marginLeft: 10, minWidth: 260 }}
                renderValue={() =>
                  selectedTeacher
                    ? `${selectedTeacher.schoolCode} - ${selectedTeacher.school}`
                    : 'All'
                }
                MenuProps={{
                  autoFocus: false,
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  PaperProps: {
                    style: { maxHeight: 420 },
                  },
                }}
              >
                <ListSubheader
                  style={{
                    backgroundColor: '#fff',
                    lineHeight: 'unset',
                    paddingTop: 8,
                    paddingBottom: 8,
                  }}
                >
                  <TextField
                    size="small"
                    placeholder="Search school code or school..."
                    fullWidth
                    variant="outlined"
                    value={this.state.teacherFilterSearch}
                    onChange={(e) => this.setState({ teacherFilterSearch: e.target.value })}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        e.stopPropagation()
                      }
                    }}
                  />
                </ListSubheader>
                <MenuItem value="">
                  All
                </MenuItem>
                {filteredTeachers.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.schoolCode + " - " + t.school}
                  </MenuItem>
                ))}
                {filteredTeachers.length === 0 && (
                  <MenuItem disabled value="__no_results">
                    No matching schools
                  </MenuItem>
                )}
              </Select>
            )
          })()}
          <br />
          <TextField margin="dense"
                     id="studentSearch" label="Search by name or username..."
                     fullWidth defaultValue={studentSearch}
                     onChange={(e) => this.handleStudentSearchChange(e.target.value)}
          />
          <br />
          <br />
          <ExaminerStudentsList filter={teacherFilter} search={studentSearch} exam={exam} history={this.props.history} location={this.props.location} />
        </Fragment>}
      </ExaminerContainer>
    )
  }

  componentDidMount() {

    this.reloadExam()

  }

  componentDidUpdate(prevProps: Props & RouteComponentProps, prevState: State) {
    if (prevState.hasChanges !== this.state.hasChanges) {
      this.unsavedChanges.setup(this.props.history, this.state.hasChanges, () => {
        this.setState(prev => ({ ...prev, showUnsavedDialog: true }))
      })
    }
  }

  componentWillUnmount() {
    this.unsavedChanges.cleanup()
  }

  private async reloadExam() {

    let exam = await (await request('/api/examiner/exams/' + this.props.id)).json()

    this.setState(prevState => ({ ...prevState, exam }), () => {
      // When returning from the student page (Back), scroll to the Students section.
      if (sessionStorage.getItem('examScrollToStudents')) {
        sessionStorage.removeItem('examScrollToStudents')
        let el = document.getElementById('students')
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  }

  handleOpenDateChange = async (date: any) => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, openDate: date.toString() }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handleCloseDateChange = async (date: any) => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, closeDate: date.toString() }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handleTitleChange = async (ev: any) => {

    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, title: ev.target.value }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handleTeacherFilterChange = async (ev: any) => {

    let teacherFilter = ev.target.value || undefined

    await this.setState(prevState => ({ ...prevState, teacherFilter, teacherFilterSearch: '' }))

    // Persist the school filter in the URL so it survives navigating away and pressing back.
    let params = new URLSearchParams(this.props.location.search)
    if (teacherFilter) {
      params.set('schoolFilter', teacherFilter)
    } else {
      params.delete('schoolFilter')
    }
    this.props.history.replace({ search: params.toString() })
  }

  handleStudentSearchChange = async (studentSearch: string) => {

    await this.setState(prevState => ({ ...prevState, studentSearch }))

    let params = new URLSearchParams(this.props.location.search)
    if (studentSearch) {
      params.set('studentSearch', studentSearch)
    } else {
      params.delete('studentSearch')
    }
    this.props.history.replace({ search: params.toString() })
  }

  handleChange = async (ev: any) => {

    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, [ev.target.name]: ev.target.value }
    if (ev.target.name === 'schoolAvailabilityMode' && ev.target.value === 'ALL') {
      newExam.allowedSchools = []
    }
    console.log(ev)
    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handleImportSchoolCodes = async (mode: 'replace' | 'add' = 'replace') => {
    await this.setState(prevState => ({ ...prevState, uploadMessage:'' }))
    let input = document.createElement('input')
    input.type = 'file'
    input.accept = '.csv'

    input.onchange = async (e: any) => {
      var file = e.target.files[0]
      if (!file) return
      const fileText = await file.text()

      let uploadRes = await request('/api/examiner/exams/' + this.props.id + '/allowedSchoolCodes?mode=' + mode, {
        method: 'POST',
        body: fileText,
        headers: {
          'content-type': 'text/plain'
        }
      })
      let message = await uploadRes.text()
      await this.setState(prevState => ({ ...prevState, uploadMessage: message }))
      this.reloadExam()
    }

    input.click()
  }

  handleRemoveAllowedSchool = async (schoolCode: string) => {
    if (!window.confirm(`Remove school code ${schoolCode}?`)) return

    try {
      await request('/api/examiner/exams/' + this.props.id + '/allowedSchoolCodes/' + schoolCode, {
        method: 'DELETE'
      })
      this.reloadExam()
    } catch (e) {
      alert('Error removing school code: ' + e)
    }
  }

  handleBulkRemoveAllowedSchools = async (schoolCodes: string[]) => {
    if (schoolCodes.length === 0) return
    if (!window.confirm(`Remove ${schoolCodes.length} school code(s)?`)) return

    try {
      await request('/api/examiner/exams/' + this.props.id + '/allowedSchoolCodes', {
        method: 'DELETE',
        body: JSON.stringify(schoolCodes),
        headers: {
          'content-type': 'application/json'
        }
      })
      this.reloadExam()
    } catch (e) {
      alert('Error removing school codes: ' + e)
    }
  }

  handleImportExcludedSchoolCodes = async (mode: 'replace' | 'add' = 'replace') => {
    await this.setState(prevState => ({ ...prevState, uploadMessage:'' }))
    let input = document.createElement('input')
    input.type = 'file'
    input.accept = '.csv'

    input.onchange = async (e: any) => {
      var file = e.target.files[0]
      if (!file) return
      const fileText = await file.text()

      let uploadRes = await request('/api/examiner/exams/' + this.props.id + '/excludedSchoolCodes?mode=' + mode, {
        method: 'POST',
        body: fileText,
        headers: {
          'content-type': 'text/plain'
        }
      })
      let message = await uploadRes.text()
      await this.setState(prevState => ({ ...prevState, uploadMessage: message }))
      this.reloadExam()
    }

    input.click()
  }

  handleRemoveExcludedSchool = async (schoolCode: string) => {
    if (!window.confirm(`Remove excluded school code ${schoolCode}?`)) return

    try {
      await request('/api/examiner/exams/' + this.props.id + '/excludedSchoolCodes/' + schoolCode, {
        method: 'DELETE'
      })
      this.reloadExam()
    } catch (e) {
      alert('Error removing excluded school code: ' + e)
    }
  }

  handleTeacherRubricChange = async (ev: any) => {

    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, teacherRubric: ev.target.value }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handleStudentRubricChange = async (ev: any) => {

    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, studentRubric: ev.target.value }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  addCertificate = () => {

    let input = document.createElement('input')
    input.type = 'file'

    input.onchange = async (e: any) => {

      let exam = this.state.exam as Exam


      var file = e.target.files[0]

      let uploadRes = await request(`/api/examiner/exams/${this.props.id}/uploadCertificate`, {
        method: 'POST',
        body: file
      })

      let body = await uploadRes.text()

      // body should be the sha1 hash of the image

      if (body.length !== 40) {
        console.log('upload failed: ' + body)
        return
      }

      let newExam: Exam = { ...exam, certificate: body }
      await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
    }

    input.click()


    // let newContent = { ...content, image: '' }
    // onUpdateContent(subject, newContent)
  }

  deleteCertificate = async () => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, certificate: null }
    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  downloadCertificate = async () => {
    let r = await request(`/api/examiner/exams/${this.props.id}/downloadCertificate`)
    const blob = await r.blob();
    FileSaver.saveAs(blob, `${this.state.exam!.title}_Certificate.pdf`);
  }

  addPdf = (num: number) => {

    let input = document.createElement('input')
    input.type = 'file'

    input.onchange = async (e: any) => {

      let exam = this.state.exam as Exam


      var file = e.target.files[0]

      let uploadRes = await request(`/api/examiner/exams/${this.props.id}/uploadPdf`, {
        method: 'POST',
        body: file
      })

      let body = await uploadRes.text()

      // body should be the sha1 hash of the image

      if (body.length !== 40) {
        console.log('upload failed: ' + body)
        return
      }

      let newExam: Exam = { ...exam, ['pdf' + (num == 2 ? '2' : '')]: body }
      await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
    }

    input.click()


    // let newContent = { ...content, image: '' }
    // onUpdateContent(subject, newContent)
  }

  deletePdf = async (num: number) => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, ['pdf' + (num == 2 ? '2' : '')]: null }
    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  downloadPdf = async (num: number) => {
    let r = await request(`/api/examiner/exams/${this.props.id}/downloadPdf/${num}`)
    const blob = await r.blob();
    FileSaver.saveAs(blob, `${this.state.exam!.title}_PDF${num}.pdf`);
  }


  async save() {

    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam }
    delete newExam.teacherHack

    await request('/api/examiner/exams/' + this.props.id, {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(newExam)
    })
    await this.setState(prevState => ({ ...prevState, saving: false, hasChanges: false }))
  }

  handleSave = async () => {
    await this.setState(prevState => ({ ...prevState, saving: true }))
    await this.save()
  }

  handleCancel = async () => {
    // Reload the exam data to discard changes
    await this.reloadExam()
    await this.setState(prevState => ({ ...prevState, hasChanges: false }))
  }

  handleUnsavedYes = () => {
    this.setState(prev => ({ ...prev, showUnsavedDialog: false }))
    this.unsavedChanges.confirm(this.props.history)
  }

  handleUnsavedNo = () => {
    this.setState(prev => ({ ...prev, showUnsavedDialog: false }))
    this.unsavedChanges.cancel()
  }

  async movePaper(n: number, n2: number) {

    let exam = this.state.exam as Exam

    let newExam: Exam = { ...exam }

    newExam.papers.splice(n2, 0, newExam.papers.splice(n, 1)[0])

    for (let n = 0; n < newExam.papers.length; ++n) {
      newExam.papers[n].order = n
    }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  async removePaper(paper: Paper, n: number) {
    let exam = this.state.exam as Exam

    let newExam: Exam = { ...exam }

    newExam.papers.splice(n, 1)
    //is this needed?
    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
    await request(`/api/examiner/exams/${this.props.id}/papers/${paper.id}`, {
      method: 'DELETE',
    })
  }

  addPaper = async () => {
    await this.setState(prevState => ({ ...prevState, showAddPaperDialog: true }))
  }

  onAddPaper = async (paper: Paper) => {

    await request('/api/examiner/exams/' + this.props.id + '/papers', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ id: paper.id })
    })

    await this.reloadExam()

    await this.setState(prevState => ({ ...prevState, showAddPaperDialog: false }))
  }

  onCloseAddPaperDialog = async () => {
    await this.setState(prevState => ({ ...prevState, showAddPaperDialog: false }))
  }

  handletoggleLive = async () => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, isLive: !exam.isLive }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handletoggleReleased = async () => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, marksReleased: !exam.marksReleased }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handletoggleFreePlacesUkOnly = async () => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, freePlacesUkOnly: !exam.freePlacesUkOnly }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handletoggleFreePlacesNonFeePayingOnly = async () => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, freePlacesNonFeePayingOnly: !exam.freePlacesNonFeePayingOnly }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }

  handletoggleArchived = async () => {
    let exam = this.state.exam as Exam
    let newExam: Exam = { ...exam, isArchived: !exam.isArchived }

    await this.setState(prevState => ({ ...prevState, exam: newExam, hasChanges: true }))
  }



  studentsColumns: any[] = [
    {
      name: 'Username',
      selector: 'username',
      sortable: true
    }
  ]



  remark = async () => {
    await this.setState(prevState => ({ ...prevState, remarking: true }))
    await request('/api/examiner/exams/' + this.props.id + '/remark', {
      method: 'POST'
    })
    await this.setState(prevState => ({ ...prevState, remarking: false }))
  }

  remarkAsdan = async () => {
    await this.setState(prevState => ({ ...prevState, remarking: true }))
    await request('/api/examiner/exams/' + this.props.id + '/remarkAsdan', {
      method: 'POST'
    })
    await this.setState(prevState => ({ ...prevState, remarking: false }))
  }


  downloadSignedUp = async () => {
    // await this.setState(prevState => ({ ...prevState, downloading: true}))
    let r = await request(`/api/examiner/teachers/downloadTeachers?examId=${this.props.id}&selection=ENROLLED`)

    let results = await r.text()

    var blob = new Blob([results], { type: 'text/csv' })
    FileSaver.saveAs(blob, 'signedUpTeachers.csv')
    // await this.setState(prevState => ({ ...prevState, downloading: false}))
  }

  downloadNotSignedUp = async () => {
    // await this.setState(prevState => ({ ...prevState, downloading: true}))
    let r = await request(`/api/examiner/teachers/downloadTeachers?examId=${this.props.id}&selection=CONTACT`)

    let results = await r.text()

    var blob = new Blob([results], { type: 'text/csv' })
    FileSaver.saveAs(blob, 'notSignedUpTeachers.csv')
    // await this.setState(prevState => ({ ...prevState, downloading: false}))
  }

  handleImportCSV = async () => {

    await this.setState(prevState => ({ ...prevState, uploadMessage:'' }))
    let input = document.createElement('input')
    input.type = 'file'

    input.onchange = async (e: any) => {
      var file = e.target.files[0]

      let uploadRes = await request('/api/examiner/exams/' + this.props.id + '/awardMedals', {
        method: 'POST',
        body: file,
        headers: {
          'content-type': 'text/plain'
        }
      })
      let message = await uploadRes.text()
      await this.setState(prevState => ({ ...prevState, uploadMessage: message }))
      this.reloadExam()

    }

    input.click()



  }

  handleImportCSV2 = async () => {

    await this.setState(prevState => ({ ...prevState, uploadMessage:'' }))
    let input = document.createElement('input')
    input.type = 'file'

    input.onchange = async (e: any) => {
      var file = e.target.files[0]

      let uploadRes = await request('/api/examiner/exams/' + this.props.id + '/giveExamPlaces', {
        method: 'POST',
        body: file,
        headers: {
          'content-type': 'text/plain'
        }
      })
      let message = await uploadRes.text()
      await this.setState(prevState => ({ ...prevState, uploadMessage: message }))
      this.reloadExam()

    }

    input.click()



  }
}

export default withRouter(ExaminerExamPage)
